import { createFileRoute } from '@tanstack/react-router';
import { EmployeeSalary } from '@/components/employee/salary';

export const Route = createFileRoute('/(app)/employee/salary/')({
  component: EmployeeSalaryRoute,
});

function EmployeeSalaryRoute() {
  return (
    <EmployeeSalary 
      showBackButton={false}
    />
  );
}

